import * as React from "react";
import { Image } from "components/fragments/Image";
import images from "utils/Images";
import { Geo } from "utils/WebApis";
import { VisuallyHidden } from "@react-aria/visually-hidden";
import css from "./AddressSearch.module.scss";

interface GeolocationButtonProps {
  onGeo(coords: { lat: number; long: number }): void;
}

/**
 * Renders a button that fetches a user's location
 * when clicked.
 */
const GeolocationButton: React.FC<GeolocationButtonProps> = ({ onGeo }) => {
  const [fetching, setFetching] = React.useState(false);

  const getGeo = async () => {
    setFetching(true);
    try {
      const coords = await Geo.getPosition();
      onGeo({
        lat: coords.coords.latitude,
        long: coords.coords.longitude,
      });
    } catch (error) {
      console.error(error);
    } finally {
      setFetching(false);
    }
  };

  const checkGeo = async () => {
    if (navigator.permissions) {
      // Permission API is implemented
      await navigator.permissions
        .query({
          name: "geolocation",
        })
        .then((permission) => {
          if (permission.state === "granted") {
            return getGeo();
          }
        });
    }
  };

  // The checkGeo() in UseEffect is throwing a glitch,
  //  when page is rendered and it shows restraurant location,
  //  in a few seconds it jumps to user's current location so
  //  commenting this out for now and all functionality is still
  //  intact even without this.
  React.useEffect(() => {
    // checkGeo();
  }, []);

  return (
    <button className={css["geo-button"]} onClick={getGeo}>
      <VisuallyHidden>Find my location</VisuallyHidden>
      <Image
        src={images?.icon_geo}
        className={`${css["geo-icon"]} ${fetching ? css.blink : ""}`}
        mediaName="icon_geo"
        mediaType="svg"
        alt=""
      />
    </button>
  );
};

export { GeolocationButton };
